<modal
  [modalId]="'bulk-edit-device'"
  [modalSize]="'md'"
  (close)="modalCleanup()">
  <div modal-title>
    <h3 class="d-inline text-capitalize" >Bulk Edit Devices</h3>
    <span class="bulk-edit-device-count">{{devices.length}} devices selected</span>
  </div>
  <div class="modal-inner h-100 pt-3" modal-inner>
    <form class="d-flex flex-column" id="form" [formGroup]="form" autocomplete="off">
      <mat-form-field subscriptSizing="dynamic" class="my-2 custom-form-field">
        <mat-label>Customer</mat-label>
        <mat-select required formControlName="customerId" ngDefaultControl #customerSelect>
          <mat-option *ngIf="showMixedCustomerOption" [value]="'-1'">Mixed</mat-option>
          <mat-option *ngFor="let customer of customers" [value]="customer.id">
            {{ customer.name }}
          </mat-option>
        </mat-select>
        <mat-error>Please select a customer for the device</mat-error>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic" class="my-2 custom-form-field">
        <mat-label>Asset Type</mat-label>
        <mat-select formControlName="assetTypeId" ngDefaultControl>
          <mat-option [value]="null"></mat-option>
          <mat-option *ngIf="showMixedAssetTypeOption" [value]="'-1'">Mixed</mat-option>
          <mat-option *ngFor="let assetType of assetTypes" [value]="assetType.id">
            {{ assetType.name }}
          </mat-option>
        </mat-select>
        <button matSuffix mat-icon-button (click)="openAssetTypeExpander(); $event.stopPropagation()" tabindex="-1">
            <i class="fas fa-lg fa-plus"></i>
        </button>
      </mat-form-field>
      <lookup-form [lookupName]="'Asset Type'" [listTitle]="'Asset Types'" [controllerName]="'AssetType'" 
        *ngIf="addingAssetType" (sendCloseEvent)="assetTypeExpanderClosed($event)" (sendDeleteEvent)="assetTypeDeleted()">
      </lookup-form>

      <div class="labelled-slider" [ngClass]="{'slider-with-mixed': showMixedEnabled.value, 'simple-slider': !showMixedEnabled.value}" formGroupName="enabled">
          <span>Enabled:</span>
          <span *ngIf="showMixedEnabled.value">
            <mat-checkbox formControlName="mixed" (click)="updateMixedBooleanFromMixed($event.target.checked, 'enabled')"></mat-checkbox>
            <span>Mixed</span>
          </span>
          <label class="switch" >
            <input type="checkbox" formControlName="value" (click)="updateMixedBooleanFromValue('enabled')">
            <span class="slider round" [ngClass]="{'mixed-state': showMixedEnabled.value}"></span>
          </label>
      </div>

      <div class="labelled-slider" [ngClass]="{'slider-with-mixed': showMixedRecordingMap.value, 'simple-slider': !showMixedRecordingMap.value}"  formGroupName="enableRecordingMapRequest">
          <span>Recording Map Upload:</span>
          <span *ngIf="showMixedRecordingMap.value">
            <mat-checkbox formControlName="mixed" (click)="updateMixedBooleanFromMixed($event.target.checked, 'enableRecordingMapRequest')"></mat-checkbox>
            <span>Mixed</span>
          </span>
          <label class="switch">
            <input type="checkbox" formControlName="value" (click)="updateMixedBooleanFromValue('enableRecordingMapRequest')">
            <span class="slider round" [ngClass]="{'mixed-state': showMixedRecordingMap.value}"></span>
          </label>
      </div>

      <div class="labelled-slider" [ngClass]="{'slider-with-mixed': showMixedCameraSnap.value, 'simple-slider': !showMixedCameraSnap.value}"   formGroupName="enableCamerasSnapshotRequest">
          <span>Camera Snapshots Upload:</span>
          <span *ngIf="showMixedCameraSnap.value">
            <mat-checkbox formControlName="mixed" (click)="updateMixedBooleanFromMixed($event.target.checked, 'enableCamerasSnapshotRequest')"></mat-checkbox>
            <span>Mixed</span>
          </span>
          <label class="switch">
            <input type="checkbox" formControlName="value" (click)="updateMixedBooleanFromValue('enableCamerasSnapshotRequest')">
            <span class="slider round" [ngClass]="{'mixed-state': showMixedCameraSnap.value}"></span>
          </label>
      </div>

      <mat-divider class="my-2"></mat-divider>

      <div class="bulk-edit-button-row mt-3 row px-3">
        <button mat-flat-button color="accent" id="edit" (click)="submitForm()" [disabled]="requestInProgress">
          Save Changes
        </button>
      </div>
    </form>
  </div>
</modal>